import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  Input,
  OnInit,
  Output,
  Component,
  ViewChild,
  EventEmitter,
} from '@angular/core';

import { CountdownComponent } from 'ngx-countdown';
import { MatButton } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';
import { UserSchema } from 'src/app/core/models';
import { UserService } from 'src/app/core/services';

@Component({
  selector: 'activation-get-code',
  templateUrl: './get-code.component.html',
  styleUrls: ['./get-code.component.scss'],
})
export class GetCodeComponent implements OnInit {
  @Input('userData') userData!: UserSchema;

  @Output('activation') activation!: EventEmitter<boolean>;
  @Output('changeState') changeState!: EventEmitter<
    'updatePhone' | 'confirmCode'
  >;

  @ViewChild('resendBtn') resendBtn!: MatButton;
  @ViewChild('countDown', { static: false }) countDown!: CountdownComponent;

  private _subscriptions: Subscription[] = [];
  public set subscriptions(subscription: Subscription | undefined) {
    if (subscription) {
      this._subscriptions.push(subscription);
    }
  }

  constructor(
    private snakeModal: MatSnackBar,
    private userService: UserService
  ) {
    this.activation = new EventEmitter();
    this.changeState = new EventEmitter();
  }

  ngOnInit(): void {
    const keys = Object.keys(this.activationFormGroup.value);

    for (let key of keys) {
      this.activationFormGroup
        .get(key)
        ?.setValidators([Validators.required, Validators.pattern('^[0-9]*$')]);
    }

    this.generateActivationCode(true);

    this.subscriptions = this.activationFormGroup.statusChanges
      .pipe(
        filter((data: any) => {
          if (this.activationFormGroup.valid) {
            return data;
          }
        })
      )
      .subscribe((data) => {
        this.activateUser();
      });
  }

  public firstInput!: any;
  public actionsDeactivated: boolean = true;
  public countDownConfig = {
    leftTime: 120,
    format: 'mm:ss',
  };

  public codeGeneratedSended: boolean = false;
  public activationFormGroup = new FormGroup({
    n1: new FormControl(''),
    n2: new FormControl(''),
    n3: new FormControl(''),
    n4: new FormControl(''),
    n5: new FormControl(''),
    n6: new FormControl(''),
  });

  public formGroupKeys = Object.keys(this.activationFormGroup.value);

  parseInt(str: string) {
    return str.replace(/^\D+/g, '');
  }

  onDigitInput(event: any) {
    let element;

    if (event.code !== 'Backspace') {
      const elementName = event.srcElement.attributes.rec.value;

      if (elementName === 'n1') {
        this.firstInput = event.srcElement;
      }

      if (this.activationFormGroup.get(elementName)?.valid) {
        element = event.srcElement.nextElementSibling;
      }
    }

    if (event.code === 'Backspace') {
      this.activationFormGroup.reset();
      this.firstInput.focus();
    }

    if (element == null) {
      return;
    } else {
      element.focus();
    }
  }

  togglePhoneUpdate() {
    this.changeState.emit('updatePhone');
  }

  generateActivationCode(isStart?: boolean) {
    if (!isStart) {
      this.countDown.restart();
      this.actionsDeactivated = true;
      this.activationFormGroup.reset();
    }

    this.subscriptions = this.userService
      .generateActivationCode({
        phone: this.userData.phone || '9177990379',
        reason: 'activation',
      })
      .subscribe((code: any) => {
        this.codeGeneratedSended = true;
      });
  }

  onLimitOut(some: any) {
    if (some.action === 'done') {
      this.resendBtn.disabled = false;
      this.actionsDeactivated = false;
    }
  }

  activateUser() {
    const prefix = `[activateUser]`;
    const errorMessage = 'User data does not have any *phone property';

    if (this.activationFormGroup.valid) {
      if (!this.userData.phone) {
        this.snakeModal.open(errorMessage, 'فهمیدم');
        throw new Error(prefix + errorMessage);
      }

      const dataToActivate = {
        reason: 'activation',
        code: this.gatherCode(),
      };

      this.userService.activateUser(dataToActivate).subscribe(
        (result: any) => {
          this.activation.emit(true);
          this.activationFormGroup.reset();
        },
        (error: any) => {
          this.firstInput.focus();
          this.activation.emit(false);
          this.activationFormGroup.reset();
          this.snakeModal.open('کد اشتباه است', 'فهمیدم', { duration: 1000 });
        }
      );
    }
  }

  private gatherCode() {
    let strCode = '';

    for (let key of this.formGroupKeys) {
      strCode = strCode + (this.activationFormGroup as any).value[key as any];
    }

    return +strCode;
  }

  ngOnDestroy() {
    this._subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
